import "../styles/home.css";
import myPhoto from "../photos/me.jpeg";

const professions = [
  "Computer Engineering Student",
  "Software IC Designer",
  "Aspiring Data Scientist",
  "Promising Student",
];

const stats = [
  { number: "28",     label: "Projects Made" },
  { number: "3 Yrs",  label: "Coding Experience" },
  { number: "20",     label: "Collaborations" },
];

const languages = [
  "C", "HDL (Verilog)", "Python", "HTML", "CSS", "JavaScript", "Java", "C++",
];

const uniqueLanguages = [...new Set(languages)];

export default function Home({ navigateTo }) {
  return (
    <div className="home-page">
      <div className="home-hero">

        {/* ── Left: text content ── */}
        <div className="home-hero__text">
          <p className="home-hero__greeting">Hello, I'm</p>
          <h1 className="home-hero__name">Justin Zedrick P. Tundag</h1>

          {/* Stats row */}
          <div className="home-divider" />
          <div className="home-stats">
            {stats.map((s) => (
              <div key={s.label} className="home-stats__item">
                <span className="home-stats__number">{s.number}</span>
                <span className="home-stats__label">{s.label}</span>
              </div>
            ))}
          </div>
          <div className="home-divider" />

          {/* Languages */}
          <div className="home-divider" />
          <div className="home-languages">
            <p className="home-languages__label">— Languages —</p>
            <div className="home-languages__list">
              {languages.map((lang) => (
                <span key={lang} className="home-languages__tag">{lang}</span>
              ))}
            </div>
          </div>
          <div className="home-divider" />

          {/* Taglines */}
          <p className="home-hero__tagline">
            A passionate student who loves building clean, purposeful software.
            Currently studying Computer Engineering and exploring the intersection
            of technology and real-world impact.
          </p>

          <p className="home-hero__tagline">
            Driven by a vision to harness data and intelligent systems, I aim to
            become a Data Scientist who transforms raw information into meaningful
            decisions. At the same time, I am deeply interested in hardware-level
            design — working toward a future where I contribute to Software IC
            design, bridging the gap between low-level engineering and high-impact
            software solutions.
          </p>
        </div>

        {/* ── Right: photo + professions + buttons ── */}
        <div className="home-hero__right">

          <div className="home-hero__photo-wrap">
            <div className="home-hero__photo-ring" />
            <div className="home-hero__photo">
              <img src={myPhoto} alt="Justin Zedrick P. Tundag" className="home-hero__photo-img" />
            </div>
          </div>

          {/* Professions below photo */}
          <div className="home-professions">
            <p className="home-professions__label">— Profession —</p>
            <div className="home-professions__list">
              {professions.map((p) => (
                <span key={p} className="home-professions__tag">{p}</span>
              ))}
            </div>
          </div>

          {/* Buttons below professions */}
          <div className="home-hero__actions">
            <button className="home-hero__btn home-hero__btn--primary" onClick={() => navigateTo('Resume')}>
              View Resume
            </button>
            <button className="home-hero__btn home-hero__btn--primary" onClick={() => navigateTo('Contact')}>
              Get In Touch
            </button>
          </div>

        </div>
      </div>
    </div>
  );
}